import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Document } from './document.model';
import documentService from './document.service';

// namespace
export const DOCUMENT_STORE_NAMESPACE = 'documentStore';

// state
interface DocumentState {
  documents: Document[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: DocumentState = {
  documents: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<DocumentState> = {
  [mutationConstant.FETCH]: (state: DocumentState, documents: Document[]) => {
    state.documents = documents;
  },
  [mutationConstant.PENDING]: (state: DocumentState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: DocumentState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: DocumentState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<DocumentState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<DocumentState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      documentService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<DocumentState, RootState> = {
  [getterConstant.ALL]: (state: DocumentState) => state.documents,
  [getterConstant.BY_ID]: (state: DocumentState) => (id: number) => state.documents.find(m => m.id === id),
  [getterConstant.STATUS]: (state: DocumentState) => state.status,
};

// module
const module: Module<DocumentState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const DocumentGetter = {
  ALL: `${DOCUMENT_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${DOCUMENT_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${DOCUMENT_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const DocumentAction = {
  FETCH: `${DOCUMENT_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
